import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { actionModalMessages } from "../../../orchestrator.messages";

interface StringListInputProps {
  value: string;
  onChange: (value: string) => void;
}

export function StringListInput({ value, onChange }: StringListInputProps) {
  const intl = useIntl();

  return (
    <div>
      <input
        type="text"
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={intl.formatMessage(actionModalMessages.valuePlaceholder)}
        className="w-full border rounded px-3 py-2"
      />
      <div className="text-gray-500 text-xs mt-1">
        <FormattedMessage {...actionModalMessages.valueHelper} />
      </div>
    </div>
  );
}
